import { ValuePropCard } from "./ValuePropCard";

export const VALUE_PROPS_SECTION_ID = "value-props";

export const HomePageValuePropSection = () => {
    return (
        <section
            id={VALUE_PROPS_SECTION_ID}
            className="bg-base-200 scroll-mt-20"
        >
            <div className="max-w-6xl mx-auto px-4 py-12 lg:py-20">
                <div className="max-w-2xl mx-auto text-center text-primary">
                    <h2 className="text-2xl lg:text-4xl font-bold">
                        Partner with NARA to Elevate Your Store&apos;s Offering
                    </h2>
                    <p className="mt-3 text-base lg:text-lg">
                        We offer a wide selection of high-quality products and
                        dedicated support.
                    </p>
                </div>
                <div className="mt-10 grid gap-6 grid-cols-1 md:grid-cols-3">
                    <ValuePropCard
                        imgSrc="/businesspeople-celebrating.png"
                        imgAlt="Assorted CBD, vape and kratom products"
                        title="Choose from over 2,000+ products"
                        description="CBD Oil, Vaporizers, Legal THC, Kratom—you name it, sell it."
                    />
                    <ValuePropCard
                        imgSrc="/businesspeople.jpg"
                        imgAlt="High-quality vaping devices"
                        title="High-quality Vaping Devices"
                    />
                    <ValuePropCard
                        imgSrc="/product-placeholder.svg"
                        imgAlt="Lab tested CBD and THC products"
                        title="High-quality, Lab Tested CBD & THC"
                    />
                </div>
            </div>
        </section>
    );
};
